export const CREDIT_MEMOS_GATE = 'commerce:invoices:creditMemos';
export const BYO_DIGITAL_WALLETS_GATE = 'PaymentsAccounts:EnableByoDigitalWallets';